import { ConvertHelper } from '@barthauer/abc/core';
import { LoginInfo } from '@barthauer/abc/core/authentication';
import { ICoreDataEntity, IPersistable, PersistenceService } from '@barthauer/abc/core/data';
export class ObjectsSet {
  public loginInfo: LoginInfo;
  public persist: () => PersistenceService;
  public id: string;
  private _name: string;
  public get name(): string {
    return this._name.replace('$' + this.loginInfo.displayName, '');
  }
  public set name(value: string) {
    this.persist().addObjectValue(this.objectKey, 'Designation', value, this._name);
    this._name = value;
  }
  public visibility: ObjectsSetsVisibility = ObjectsSetsVisibility.Public;
  public orderUnitType: string;
  public entities: () => Promise<ObjectSelectionItem[]>;
  public entitiesCount: number;
  public isVisibleForCurrentUser: boolean = true;
  public lastSavedDateTime: Date;

  constructor(private objectKey: IPersistable, private designation: string) {
    this._name = this.designation;
  }

  public persistPendingObject(): void {
    const pop = this.persist().getPendingObjectPackage(this.objectKey);
    if (pop?.hasAnyChanges) {
      this.persist().persistPendingChanges(this.objectKey.persistenceCategory);
    }
  }

  public checkVisibility(name: string): void {
    const userName = this.loginInfo?.displayName;
    if (name?.includes(`$${userName}`)) {
      this.visibility = ObjectsSetsVisibility.Private;
    } else if (name?.includes('$')) {
      this.isVisibleForCurrentUser = false;
    }
  }

  public changeVisibility(visibility: ObjectsSetsVisibility): void {
    if (visibility === ObjectsSetsVisibility.Private) {
      return this.makePrivate();
    } else {
      return this.makePublic();
    }
  }

  private makePrivate(): void {
    if (!this.name?.includes('$' + this.loginInfo.displayName)) {
      this.name = this.name.concat('$' + this.loginInfo.displayName);
    }
    this.visibility = ObjectsSetsVisibility.Private;
  }

  private makePublic(): void {
    if (this._name?.includes('$' + this.loginInfo.displayName)) {
      this.name = this._name.replace('$' + this.loginInfo.displayName, '');
    }
    this.visibility = ObjectsSetsVisibility.Public;
  }
}

export class ObjectSelection implements ICoreDataEntity {
  Id: string;
  ObjectType: string | number;
  Designation: string;
  ContainerId: string;
  ObjectTypeRef: number;
  ReferencedId: string;
  ReferencedObjectType: number;
  SysDateUpdate: Date;
  SysTimeUpdate: Date;
  ObjectSelectionItemCount: number;

  constructor(selection: any) {
    Object.assign(this, selection);
  }
}

export class ObjectSelectionItem implements ICoreDataEntity {
  Id: string;
  ObjectType: string | number;
  IdObjectSelectionItem: string;
  Id_DisplayText: string;
  ObjectType_DisplayText: string = '';
  constructor(item: unknown) {
    Object.assign(this, item);
  }
}

export enum ObjectsSetsVisibility {
  Public = 'Public',
  Private = 'Private',
}

export class ObjectsSetHelper {
  public static setLastSavedDateTime(date: Date, time: Date): Date {
    const dateTime = new Date(date);
    const newTime = new Date(time);
    dateTime.setHours(newTime.getHours(), newTime.getMinutes(), newTime.getSeconds());
    return dateTime;
  }

  public static getFormattedDateTime(dateTime: Date) {
    return ConvertHelper.toLocaleFormattedDateTimeString(dateTime)?.replace(',','');
  }
}
